export const facebookLikeMetaData = {
    isRepeatable: false
}
